<div class="recap">
  <div class="header">
    <wz-icon>car</wz-icon>
    <div class="vehicle-name">
      <div class="marque">{{ car.marque }} {{ car.modele }}</div>
      <div class="version" *ngIf="car.version !== 'none'">
        {{ car.version }}
      </div>
    </div>
  </div>
  <div class="separator"></div>
  <div class="line" *ngIf="car.carrosserie">
    Carrosserie : <span class="semi-bold">{{ car.carrosserie }}</span>
  </div>
  <div class="line">
    Énergie :
    <span class="semi-bold"
      >{{ car.energie }} ({{ car.chevauxFiscaux }}CV)</span
    >
  </div>
  <div class="line" *ngIf="car.typeMine && showTypeMine">
    Type mine : <span class="semi-bold">{{ car.typeMine }}</span>
  </div>
  <div class="separator"></div>

  <div class="dates">
    <ng-container *ngIf="car.dateMiseEnCirculation">
      <label>Mise en circulation : </label>
      <span class="value"> {{ car.dateMiseEnCirculation | date }}</span>
    </ng-container>
    <ng-container *ngIf="car.dateAchatVehicule">
      <label>Date d'achat :</label>
      <span class="value"> {{ car.dateAchatVehicule | date }}</span>
    </ng-container>
  </div>
</div>
